export default {
    mixins: [
    ],
    data() {
        return {
            proposals: [],
        };
    },
    methods: {}
};
